<template>
  <v-container fluid class="pl-0">
    <v-row>
      <v-col :cols="showIndividualOrgView ? 6 : 12">
        <v-card>
          <v-card-title>
            All Organizations
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="organizations"
            :search="search"
            :loading="loading"
            class="elevation-1"
            item-key="auth0_org_id"
            :items-per-page="10"
            :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
            @click:row="onRowClick"
          >
            <template v-slot:[`item.account_status`]="{ item }">
              <v-chip
                :color="item.account_status === 'active' ? 'green' : 'red'"
                dark
              >{{ item.account_status }}</v-chip>
            </template>
            <template v-slot:[`item.member_count`]="{ item }">
              <v-chip color="primary" dark>{{ item.member_count }}</v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="6" v-if="showIndividualOrgView">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'AllOrganizations',
  setup() {
    const { getAccessTokenSilently } = useAuth0();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const organizations = ref([]);
    const loading = ref(true);
    const search = ref('');

    const headers = [
      { title: 'Display Name', align: 'start', sortable: true, key: 'display_name' },
      { title: 'Name (Slug)', key: 'name' },
      { title: 'Status', key: 'account_status' },
      { title: 'Members', key: 'member_count' },
      { title: 'Owner', key: 'owner_email' },
    ];

    const fetchOrganizations = async () => {
      loading.value = true;
      try {
        const token = await getAccessTokenSilently();
        const response = await axios.get(
          `${process.env.VUE_APP_CBE_BASE_URL}/piccolo/admin/organizations`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        organizations.value = response.data;
      } catch (error) {
        store.commit('SET_ERROR_MESSAGE', error.response?.data?.detail || error.message || 'Failed to load organizations');
        store.commit('SET_SHOW_ERROR_MODAL', true);
      } finally {
        loading.value = false;
      }
    };

    const onRowClick = (event, { item }) => {
      if (item.auth0_org_id) {
        router.push({ name: 'IndividualOrganization', params: { id: item.auth0_org_id } });
      }
    };

    const showIndividualOrgView = computed(() => route.params.id !== undefined);

    onMounted(fetchOrganizations);

    return {
      organizations,
      loading,
      search,
      headers,
      onRowClick,
      showIndividualOrgView,
    };
  },
};
</script>
